module.exports = __webpack_public_path__ + "static/media/ClearFilled.7c6c5659.svg";